import api from '../../api/client';
import React from "react";
import AddStockItemPage from "../../components/PurchasePage";

const InventoryAdd = () => {
  return (
    <>
      <AddStockItemPage />
    </>
  );
};

export default InventoryAdd;
